export default "__VITE_ASSET__Yoenx7hq__"